import { initializeApp } from "firebase/app";
//import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Follow this pattern to import other Firebase services
// import { } from 'firebase/<service>';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyDChk2iBJ1Usty1QIXBLD_46wjXxSfpQiw",
  authDomain: "ecobuq.firebaseapp.com",
  projectId: "ecobuq",
  storageBucket: "ecobuq.appspot.com",
  messagingSenderId: "446264847262",
  appId: "1:446264847262:web:06f2b298ba39eb483b048f",
  measurementId: "G-R7XNW6C9ST",
};
console.log("inicializando App");
const app = initializeApp(firebaseConfig);
const auth = getAuth();
export const db = getFirestore(app);
export { auth };
db._settings.experimentalAutoDetectLongPolling = true;
//connectFirestoreEmulator(db, "localhost", 8090);
